import { useEffect } from 'react';
import { setMuted } from '@/lib/audio';
import { useAppStore } from '@/lib/store';
import { Icon } from './Icon';

export function AudioToggle(): JSX.Element {
  const muted = useAppStore((s) => s.audioMuted);
  const toggle = useAppStore((s) => s.toggleAudio);

  // Sync audio engine on mount + when muted flag changes.
  useEffect(() => { setMuted(muted); }, [muted]);

  return (
    <button
      onClick={toggle}
      aria-label={muted ? '开启音效' : '静音'}
      title={muted ? '开启音效' : '静音'}
      className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-ink-900/60 border border-honey-500/20 hover:border-honey-500/50 text-cream-300 hover:text-honey-300 transition-colors"
    >
      <Icon name={muted ? 'mute' : 'listen'} size="md" />
    </button>
  );
}
